(function () {
  'use strict';

  angular.module('irricrops')


      .directive('bindOnce', function () {
        return {
          scope : true,
          link  : function ($scope) {
            setTimeout(function () {
              $scope.$destroy();
            }, 0);
          }
        }
      })


      //http://stackoverflow.com/questions/15417125/submit-form-on-pressing-enter-with-angularjs
      .directive('ngEnter', function () {
        return function (scope, element, attrs) {
          element.bind("keydown keypress", function (event) {
            var valid = true;
            if (angular.isDefined(attrs.ngEnterCondition)) {
              valid = scope.$eval(attrs.ngEnterCondition, {'event' : event});
            }
            if (event.which === 13 && valid) {
              scope.$apply(function () {
                scope.$eval(attrs.ngEnter, {'event' : event});
              });
              event.preventDefault();
            } else {
              //console.log("ng-enter invalid");
            }
          });
        };
      })

      .directive('repeatDone', function () {
        return function (scope, element, attrs) {
          if (scope.$last) { // all are rendered
            scope.$eval(attrs.repeatDone);
          }
        };
      })

      .directive('myScrollable', ['$window', '$timeout', function ($window, $timeout) {
        return {
          restrict : 'C',
          require  : 'scrollbar',
          link     : function (scope, element, attrs, scrollbar) {

            scope.initializeWindowSize = function () {
              scope.windowHeight = $window.innerHeight;
              scope.windowWidth  = $window.innerWidth;
              $timeout(function () {
                scrollbar.update();
              }, 100);
            };
            angular.element($window).bind("resize", function () {
              scope.initializeWindowSize();
            });
            scope.initializeWindowSize();
          }
        };
      }])


      //https://docs.angularjs.org/error/ngModel/numfmt
      .directive('stringToNumber', function () {
        return {
          require : 'ngModel',
          link    : function (scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (value) {
              return '' + value;
            });
            ngModel.$formatters.push(function (value) {
              return parseFloat(value);
            });
          }
        }
      })

      .directive('numbersOnly', function () {
        return {
          require : 'ngModel',
          link    : function (scope, element, attrs, modelCtrl) {
            modelCtrl.$parsers.push(function (inputValue) {
              if (inputValue === undefined || inputValue === null) return '';
              if (typeof inputValue == 'number') {
                inputValue = inputValue.toString();
              }
              var transformedInput = 0;
              if (angular.isDefined(attrs.entero)) {
                transformedInput = inputValue.replace(/[^0-9 -]/g, '');
              } else {
                transformedInput = inputValue.replace(",", ".");
                transformedInput = transformedInput.replace(/[^0-9 . -]/g, '');
              }
              if(transformedInput != ""){
                transformedInput = parseFloat(transformedInput);
              }
              if (transformedInput != inputValue) {
                modelCtrl.$setViewValue(transformedInput);
                modelCtrl.$render();
              }

              return transformedInput;
            });
          }
        };
      })











.directive("sensorMiniChart", function() {
  return {
    restrict: "EA",
    template:
      "<div class='sensor-mini'><svg class='icon-sm' width='50' height='50'></svg></div>",
    link: function(scope, elem, attrs) {

      var data      = _.get(scope,attrs.chartData);
      var sensor    = data.sensor;
      var lim       = data.limites;
      //var d3        = $window.d3;
      var rawSvg    = elem.find("svg");
      var svg       = d3.select(rawSvg[0]);
      var margin    = { top: 0, right: 14, bottom: 0, left: 6 };
      var width     = +svg.attr("width") - margin.left - margin.right;
      var height    = +svg.attr("height") - margin.top - margin.bottom;

      var g = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      var widthChart = width + 4;
      var color = {
        saturacion: {
          hard: "#2196f3", // blue 500
          light: "#90caf9" // blue 200
        },
        cc: {
          hard: "#4caf50", // green 500
          light: "#a5d6a7" // green 200
        },
        pmp: {
          hard: "#f44336", // red 500
          light: "#ef9a9a" // red 200
        }
      };

      var getIconColor = function(num) {
        if (num > lim.cc) {
          return color.saturacion.hard;
        }
        if (num > lim.pmp) {
          return color.cc.hard;
        }
        return color.pmp.hard;
      };

      var x = d3
        .scaleTime()
        .rangeRound([0, width])
        .domain(
          d3.extent(sensor, function(d) {
            return d.date;
          })
        );

      var y = d3.scaleLinear().rangeRound([height, 0]);

      var y_min = _.minBy(sensor, function(o) {
        return o.close;
      });
      var y_max = _.maxBy(sensor, function(o) {
        return o.close;
      });
      var m = (y_max.close - y_min.close) * 0.2;

      y.domain([y_min.close - m, y_max.close + m]);

      g
        .append("rect")
        .attr("x", -1)
        .attr("y", 0)
        .style("width", widthChart)
        .style("height", y(lim.cc))
        .style("fill", color.saturacion.light);

      g
        .append("rect")
        .attr("x", -1)
        .attr("y", y(lim.cc))
        .style("width", widthChart)
        .style("height", y(lim.pmp) - y(lim.cc))
        .style("fill", color.cc.light);

      g
        .append("rect")
        .attr("x", -1)
        .attr("y", y(lim.pmp))
        .style("width", widthChart)
        .style("height", height - y(lim.pmp))
        .style("fill", color.pmp.light);

      var line = d3
        .line()
        .x(function(d) {
          return x(d.date);
        })
        .y(function(d) {
          return y(d.close);
        });

      g
        .append("path")
        .datum(sensor)
        .style("fill", "none")
        .style("stroke", "#263238") //blue grey 900
        .style("stroke-linejoin", "round")
        .style("stroke-linecap", "round")
        .style("stroke-width", 1.5)
        .attr("d", line);

      var symbol = d3
        .symbol()
        .size(50)
        .type(d3.symbolTriangle);

      g
        .append("path")
        .attr("d", symbol)
        .attr(
          "transform",
          "translate(" +
            (widthChart + 6) +
            "," +
            y(sensor[sensor.length - 1].close) +
            ") rotate(-90)"
        )
        .style("stroke", "#253544")
        .style("stroke-width", "1px")
        .style("fill", getIconColor(sensor[sensor.length - 1].close));
    }
  };
});




















})();
